interface ChatIconProps {
  className?: string;
  eyes?: boolean;
}

export function ChatIcon({ className, eyes = true }: ChatIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        d="M21.8,10.4c0-3.7-3.1-6.6-6.8-6.6h-6.6c-3.7,0-6.6,3-6.6,6.7s3,6.7,6.6,6.7h0s4,0,4,0c.4,1.5,1.6,2.7,3.1,3,.5.1.9-.2.9-.7v-2.4c5.7-1.4,5.4-6.6,5.4-6.6Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {eyes && (
        <>
          <path
            fill="currentColor"
            stroke="none"
            d="M8.5,11.7c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3,1.3.6,1.3,1.3-.6,1.3-1.3,1.3Z"
          />
          <path
            fill="currentColor"
            stroke="none"
            d="M15.3,11.7c-.7,0-1.3-.6-1.3-1.3s.6-1.3,1.3-1.3,1.3.6,1.3,1.3-.6,1.3-1.3,1.3Z"
          />
        </>
      )}
    </svg>
  );
}
